import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=204f7987&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=204f7987&prod&lang=css"
import style1 from "./Search.vue?vue&type=style&index=1&id=204f7987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f7987",
  null
  
)

export default component.exports